module.exports = __webpack_public_path__ + "static/logo-carepostcard-dark-86a93405bf024f16490a17e781ba7a1b.svg";